import router from './index'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style

NProgress.configure({ showSpinner: false })// NProgress Configuration

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  //路由权限控制

  next()
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})






// WEBPACK FOOTER //
// ./src/router/manage.js